import {BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate} from "react-router-dom";
import ScrollToTop from "./types/ScrollToTop";
import Header from "./components/Header";
import Landing from "./pages/Landing";
import Footer from "./components/Footer";
import {useEffect, useState} from "react";
import Login from "./admin/Login";
import ScrollToTopButton from "./components/ScrollToTopButton";
import Systems from "./pages/Systems";
import Development from "./pages/Development";
import Studios from "./pages/Studios";
import Imprint from "./pages/Imprint";
import ItAdministratorMuenchen from "./pages/ItAdministratorMuenchen";
import WebentwicklerMuenchen from "./pages/WebentwicklerMuenchen";
import FotografMuenchen from "./pages/FotografMuenchen";
import Support from "./pages/Support";
import SupportWindows from "./pages/SupportWindows";
import SupportMac from "./pages/SupportMac";

interface ProtectedRouteProps {
    element: any;
    allowedRoles: string[];
}

const checkTokenValidity = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
        return false;
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/validate-token`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error("Token validation failed");
        }

        const data = await response.json();
        return data.valid;
    } catch (error) {
        console.error("Token validation error:", error);
        return false;
    }
};

const logoutUser = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
};

const App = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, allowedRoles }) => {
        const [allowed, setAllowed] = useState<null | boolean>(null);

        useEffect(() => {
            (async () => {
                const tokenOk = await checkTokenValidity();
                const userRaw = localStorage.getItem("user");
                const user = userRaw ? JSON.parse(userRaw) : null;
                const roleOk = user && allowedRoles.includes(user.role);
                setAllowed(Boolean(tokenOk && roleOk));
            })();
        }, [allowedRoles]);

        if (allowed === null) return null; // or a spinner
        return allowed ? element : <Navigate to="/login" replace />;
    };

    return (
        <>
            <div className="app">
                <Header />

                <div className="mainDashboard">
                    <Routes>
                        <Route path="/" element={<Landing/>} />
                        <Route path="/contact" element={<Navigate to="/" replace />} />
                        <Route path="/systems" element={<Systems/>} />
                        <Route path="/dev" element={<Development/>} />
                        <Route path="/studios" element={<Studios/>} />
                        <Route path="/imprint" element={<Imprint/>} />

                        <Route path="/it-administrator-muenchen" element={<ItAdministratorMuenchen />} />
                        <Route path="/webentwickler-muenchen" element={<WebentwicklerMuenchen />} />
                        <Route path="/fotograf-muenchen" element={<FotografMuenchen />} />

                        {/*Fernwartung (RustDesk)*/}
                        <Route path="/support" element={<Support />} />
                        <Route path="/support-w" element={<SupportWindows />} />
                        <Route path="/support-m" element={<SupportMac />} />


                        {/*Admin Dashboard*/}
                        <Route path="login" element={<Login/>} />
                    </Routes>

                </div>

                <ScrollToTopButton />
                <Footer/>
            </div>
        </>
    );
};

const AppWrapper = () => (
    <Router>
        <ScrollToTop />
        <App />
    </Router>
);

export default AppWrapper;